<div class="item" [class.item-updating]="form.updating">
  <span class="item-updating-icon cc-icon cc-icon-spinner-lg"></span>
  <cc-form-field-thumbnail *ngFor="let field of thumbnailFields" [field]="field"></cc-form-field-thumbnail>
</div>
